import { createTheme } from "@mui/material/styles"

const theme = createTheme({
	palette: {
		mode: "dark",
		primary: { main: "#fff" },
		secondary: { main: "#fff" },
		background: {
			paper: "#1E1E1E"
		}
	},
	typography: {
		fontFamily: ["Graphik"].join(","),
		fontSize: 14,
		fontWeightLight: 300,
		fontWeightRegular: 400,
		fontWeightMedium: 500,
		button: {
			textTransform: "none",
		},
	},
	components: {
		MuiPaper: {
			styleOverrides: {
				root: {
					backgroundColor: "#34383B",
				},
			},
		},
		MuiBadge: {
			styleOverrides: {
				root: {
					borderRadius: "100%",
				},
			},
		},
		MuiSelect: {
			styleOverrides: {
				root: {
					color: "white",
				},
				icon: {
					color: "white",
				},
			},
		},
		MuiTabs: {
			styleOverrides: {
				flexContainer: {
					justifyContent: "center",
					minWidth: "max-content",
				},
				indicator: {
					backgroundColor: "white",
				},
				scroller: {
					height: "100%",
				},
			},
		},
		MuiTab: {
			styleOverrides: {
				root: {
					textTransform: "none",
					fontFamily: "Graphik",
				},
				wrapper: {
					color: "#1C1C1D",
				},
			},
		},
		MuiFormLabel: {
			styleOverrides: {
				root: {
					color: "rgba(255, 255, 255, 0.7)",
					"&$focused": {
						color: "rgba(255, 255, 255, 0.7)",
					},
				},
			},
		},
		MuiPopover: {
			styleOverrides: {
				root: {
					maxHeight: "35em",
				},
			},
		},
		MuiInputBase: {
			styleOverrides: {
				root: {
					fontFamily: "Graphik",
				},
				multiline: {
					padding: "none",
				},
			},
		},
		MuiOutlinedInput: {
			styleOverrides: {
				notchedOutline: {
					borderColor: "white",
				},
			},
		},
		MuiFormControlLabel: {
			styleOverrides: {
				root: {
					color: "white",
				},
			},
		},
		MuiButtonBase: {
			styleOverrides: {
				root: {
					fontFamily: "Graphik",
				},
			},
		},
		MuiAvatarGroup: {
			styleOverrides: {
				avatar: {
					border: "none",
				},
				root: {
					justifyContent: 'flex-end'
				}
			},
		},
		MuiAvatar: {
			styleOverrides: {
				root: {
					border: "none !important",
				},
			}
		},
		MuiDataGrid: {
			styleOverrides: {
				root: {
					border: 'none'
				},
				main: {
					overflow: 'initial',
				},
				columnHeaders: {
					position: 'sticky',
					zIndex: 1,
				},
				toolbarContainer: {
					justifyContent: 'end',
					marginRight: '1em',
					marginTop: '-3em',
				},
				virtualScroller: {
					marginTop: '0px !important',
				},
			},
		},
	},
})

export default theme
